import ActivityWrapper from '~/bootcamp/Activities/components/ActivityWrapper'
import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'
import { useEmitInstance } from '~/bootcamp/Activities/utils/instance.utils'
import AlgebraActivityWrapper from '~/bootcamp/Activities/Algebra/Components/AlgebraActivityWrapper'

import useClickVariable from './useClickVariable'
import { TermsType } from './ClickVariable.utils'

function ClickVariable({
  answerState,
  actionButtonsFC,
  difficultyLevel,
  onAnswerStateChange,
  onInstanceChange,
  onNextQuestionClick,
}: ActivityProps): React.ReactElement {
  const { clickableParts, formValid, onInputChange, handleCheckAnswer, goToNextQuestion } = useClickVariable({
    difficultyLevel,
    onAnswerStateChange,
    onNextQuestionClick,
  })

  // `isClicked`/`type` stay out — which token is the variable is the answer being tested.
  // The painted '×' is decorative (SIGNS in ClickVariable.utils.ts) — emit the normalized '\cdot'.
  useEmitInstance(
    onInstanceChange,
    clickableParts?.length
      ? clickableParts
          .map(({ data }) => data)
          .join(' ')
          .replaceAll('×', '\\cdot')
      : null,
  )

  return (
    <ActivityWrapper>
      <AlgebraActivityWrapper>
        <div className="flex flex-row text-lg">
          {clickableParts &&
            clickableParts.map(({ data, isClicked, type }, i) => (
              <div
                className={`transition duration-100 ease-in-out mx-1 cursor-pointer ${
                  clickableParts[i].type === TermsType.COEFFICIENT && '-mr-1'
                } ${
                  answerState === false &&
                  ((isClicked && type !== TermsType.VARIABLE) || (!isClicked && type === TermsType.VARIABLE))
                    ? 'text-red'
                    : ''
                } ${isClicked ? 'text-purple scale-110' : 'text-black'}`}
                key={data + i.toString()}
                onClick={onInputChange.bind(null, i)}
              >
                {type === TermsType.VARIABLE ? <i>{data}</i> : data}
              </div>
            ))}
        </div>
      </AlgebraActivityWrapper>
      {actionButtonsFC &&
        actionButtonsFC({
          formValid,
          correctAnswer: answerState ?? false,
          submitAnswerAction: handleCheckAnswer,
          clearFormAction: () => onInputChange(),
          goToNextQuestionAction: goToNextQuestion,
        })}
    </ActivityWrapper>
  )
}

export default ClickVariable
